// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mIpD","col":"styles_col__3x1YN"};